import React, { Fragment, useEffect, useRef } from 'react';
import { products, global } from 'actions';
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";

import { t } from 'translates';
import SessionFilter from 'apps/sessions-new-filter/SessionsNewFilter';

import ProductListSection from './components/ProductListSection';
import NoResult from './components/NoResult';
import Spinner from 'common/components/Spinner';

const ecommerceStatus  = window.drupalSettings && window.drupalSettings.ecommerceStatus ? window.drupalSettings.ecommerceStatus : false;

function Products() {
  const dispatch = useDispatch();
  const courses = useSelector(state => state.products.courses);
  const conferences = useSelector(state => state.products.conferences);
  const exhibitions = useSelector(state => state.products.exhibitions);
  const noResult = useSelector(state => state.products.no_result);
  const wrapperRef = useRef();
  const loading = useSelector(state => state.products.spinner);

  useEffect(() => {
    dispatch(products.fetch(true));
    const { parentNode } = wrapperRef.current;
    const { itemListName } = parentNode.dataset;
    dispatch(global.setItemListName(itemListName));
  }, []);

  return (
    <div ref={wrapperRef} className="products-list__container">
      <SessionFilter type="list">
        {() => (
          loading ? (
            <Spinner isInner />
          ) : (
            <Fragment>
              {Object.keys(noResult).length > 0 ? (
                <NoResult noResult={noResult} />
              ) : (
                <div className={classNames('products-list', { 'disable-ecommerce': !ecommerceStatus })}>
                  <Fragment>
                    {!!courses.length && (
                      <ProductListSection itemListName='product listing' array={courses} label={t('Courses', DT_SESSIONSNEW)}/>
                    )}
                    {!!conferences.length && (
                      <ProductListSection itemListName='product listing' array={conferences} label={t('Conferences', DT_SESSIONSNEW)} />
                    )}
                    {!!exhibitions.length && (
                      <ProductListSection itemListName='product listing' array={exhibitions} label={t('Exhibitions', DT_SESSIONSNEW)}/>
                    )}
                  </Fragment>
                </div>
              )}
            </Fragment>
          )
        )}
      </SessionFilter>
    </div>
  );
}

export default Products;
